import { Dispatch, SetStateAction } from 'react';
import MyModal from '../../../../../../components/Modal';
import { ArquivoBase } from '../../../types';

interface IFinishProcessModal {
  setFinishProcessModalShow: Dispatch<SetStateAction<boolean>>;
  finishProcess: (baseFiles: ArquivoBase[]) => Promise<void>;
  baseFiles: ArquivoBase[];
  finishProcessModalShow: boolean;
}

export default function FinishProcessModal({
  setFinishProcessModalShow,
  finishProcess,
  baseFiles,
  finishProcessModalShow,
}: IFinishProcessModal) {
  console.log('FinishProcessModal', baseFiles);
  return (
    <MyModal
      title={'Finalizar Processo'}
      closeButtonLabel="Cancelar"
      actionButtonLabel="Finalizar"
      modalBody={(
        <div>
          Tem certeza que deseja finalizar este processo na data de hoje?
        </div>
      )}
      onClose={() => setFinishProcessModalShow(false)}
      onAction={() => finishProcess(baseFiles)}
      show={finishProcessModalShow}
      type="action"
    />
  );
}
